import { useMemo } from 'react'
import { useDataValue } from 'Simple/Data'

/** @type {import('Simple/types.js').useDataTransform} */
export default function useDataTransform(props, data) {
  let image_series_id = useDataValue({
    context: 'tab',
    path: 'selected.images.image_series_id',
    viewPath: props.viewPath,
  })

  return useMemo(() => {
    if (
      !data ||
      (!data.connection_resources.length && !data.connection_patients.length)
    )
      return null

    let {
      connection_resources: [connection_resource],
      connection_patients: [connection_patient],
    } = data

    return {
      id:
        connection_patient?.connection.id || connection_resource?.connection.id,
      app_id:
        connection_patient?.connection.app_id ||
        connection_resource?.connection.app_id,
      step: 'account',
      account_id:
        connection_patient?.connection.resources?.[0]?.properties?.accountId ||
        connection_resource?.properties?.accountId,
      doctor_id:
        connection_patient?.connection.resources?.[0]?.properties?.doctorId ||
        connection_resource?.properties?.doctorId,
      image_series_id,
      set_preferred: true,
    }
  }, [data, image_series_id])
}
